export const DefaultPageSize: number = 20;
export const DefaultPage: number = 1;
export const DefaultLinkName: string = 'PartnershipInformationList';
export const DefaultTenantId: string = '00000000-0000-0000-0000-000000000000';
export const DefaultPollingInterval: number = 60000;
